import axios from 'axios'

// Data Logger (Live) device API client.
// Mirrors projectsApi.js: same base URL / JWT-in-localStorage / Bearer header.
const API_URL = import.meta.env.VITE_API_URL || 'https://wqlive.ezxdemo.com'
const API_BASE_PATH = import.meta.env.VITE_API_BASE_PATH || '/api'
const JWT_STORAGE_KEY = import.meta.env.VITE_JWT_STORAGE_KEY || 'auth_token'

const getAuthHeaders = () => {
  const token = localStorage.getItem(JWT_STORAGE_KEY)
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  }
}

const base = (projectId, deviceId) =>
  `${API_URL}${API_BASE_PATH}/project/${projectId}/device/${deviceId}`

export const deviceApi = {
  /** GET device header info (name, uid, firmware strings, last contact). */
  async fetchDevice(projectId, deviceId) {
    const res = await axios.get(`${base(projectId, deviceId)}/`, { headers: getAuthHeaders() })
    return res.data
  },

  /** GET Sample/Log/Transmit config grouped by sensor. */
  async fetchConfig(projectId, deviceId) {
    const res = await axios.get(`${base(projectId, deviceId)}/config/`, { headers: getAuthHeaders() })
    return res.data
  },

  /** Update device name (queues logger command #6). */
  async updateName(projectId, deviceId, name) {
    const res = await axios.post(
      `${base(projectId, deviceId)}/name/`,
      { name },
      { headers: getAuthHeaders() }
    )
    return res.data
  },

  /** Queue a device reset (command #4). */
  async resetDevice(projectId, deviceId) {
    const res = await axios.post(`${base(projectId, deviceId)}/reset/`, {}, { headers: getAuthHeaders() })
    return res.data
  },

  /** Queue an RTC clock sync (command #62). */
  async syncClock(projectId, deviceId) {
    const res = await axios.post(`${base(projectId, deviceId)}/sync-clock/`, {}, { headers: getAuthHeaders() })
    return res.data
  },

  /**
   * Format Memory — backend returns 501 until the device command is confirmed.
   * Kept here so the UI can surface the reason rather than hide the action.
   */
  async formatMemory(projectId, deviceId) {
    const res = await axios.post(`${base(projectId, deviceId)}/format-memory/`, {}, { headers: getAuthHeaders() })
    return res.data
  },
}

export default deviceApi
